import * as Scrivito from "scrivito";

const Download = Scrivito.provideObjClass("Download", {
  attributes: {
    blob: "binary",
    tags: "stringlist",
    title: "string",
  },
  extractTextAttributes: ["title"],
});

export default Download;
